/**
 * Normalize user/homenew responses that use nearbyHosts vs legacy array shapes.
 */
import { pickAddress, pickId, pickTitle, resolvePublicAssetUrl } from "./clubDetailHelpers";

export function pickHostCardImage(item) {
  if (!item || typeof item !== "object") return "";
  const raw = item.businessPicture || item.profilePicture || item.businessBanner || "";
  if (!raw || typeof raw !== "string") return "";
  const u = resolvePublicAssetUrl(raw.trim());
  return u || "";
}

export function formatHostDistance(distance) {
  if (distance == null || distance === "") return "";
  const s = String(distance).trim();
  if (!s) return "";
  if (/away$/i.test(s)) return s;
  return `${s} away`;
}

function asLegacyList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  const keys = [
    "nearbyHosts",
    "featuredList",
    "data",
    "list",
    "items",
    "events",
    "event",
    "club",
    "clubs",
    "host",
    "hosts",
    "result",
    "rows",
  ];
  for (const key of keys) {
    if (Array.isArray(payload[key])) return payload[key];
  }
  return [];
}

/** Raw rows from API (objects), not yet mapped to card shape. */
export function pickNearbyHostRows(res) {
  if (res && Array.isArray(res.nearbyHosts)) return res.nearbyHosts;
  return asLegacyList(res);
}

export function mapHostRowToCardItem(item, index) {
  const id = pickId(item) || String(item?.clubId || item?.hostId?._id || item?.hostId || `row-${index}`);
  const title = pickTitle(item);
  const address = pickAddress(item);
  const image = pickHostCardImage(item);
  const description = String(
    item?.businessDiscription || item?.description || item?.details || item?.about || item?.shortDescription || ""
  ).trim();
  const distance = formatHostDistance(
    item?.distance ?? item?.distanceInMiles ?? item?.miles ?? item?.nearByDistance ?? ""
  );
  return { id, title, address, image, description, distance, raw: item };
}

export function extractNearbyHostsForCards(res) {
  return pickNearbyHostRows(res).map((item, index) => mapHostRowToCardItem(item, index));
}
